<template>
  <div>
      <FrameIframe v-if="fileId && fileType !== 'others'" :file-id="fileId" class="frame"></FrameIframe>
    <!-------------------------------------------视频---------------------------------------------->
    <el-card class="box-card" style="height: 100%;display: flex;justify-content: center;" v-if="fileType === 'others'">
      <div style="padding: 5px 0; width: 1000px; word-wrap: break-word;text-align: center">
        <span style="font-size: 15px; white-space: normal;">{{ introduction }}</span>
      </div>
      <div class="myVideo" v-if="fileType === 'others'">
        <video
            id="myVideo"
            :src="url"
            :controls="controls"
            oncontextmenu="return false"
            style="width: 100%;height: 100%;object-fit:fill;" >
        </video>
      </div>
    </el-card>
  </div>
</template>

<script>


export default {
  name: "FileViewer",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      fileType: '',
      fileId: '',
      introduction:'',
      url:'',
      controls: true,//是否显示控件
    }
  },
  methods: {
    calcFileType(suffix) {
      switch (suffix) {
        case '.pdf':
          return 'pdf';
        case '.png':
        case '.jpg':
        case '.jpeg':
        case '.gif':
        case '.bmp':
          return 'img';
        case '.doc':
        case '.docx':
          return 'word';
        case '.xls':
        case '.xlsx':
          return 'excel';
        case '.ppt':
        case '.pptx':
          return 'ppt';
      }

      return 'others'
    },
  },
  async created() {
    let suffix = this.parentData.suffix.toLowerCase();
    this.fileType = this.calcFileType(suffix);
    let data = await this.$http('prjKnowledgeService.getById', this.parentData)
    console.log(data)
    this.fileId = data.file_id
    this.url = data.url
    this.introduction = data.introduction
  }
}
</script>

<style scoped>
/*视频样式*/
.myVideo {
  padding:0;
  border: 1px solid lightgrey;
  height:600px;
  width: 1000px;
}

img {
  height: 100%;
  width: auto;
  position: relative;
}
.frame {
  height: calc(100% - 8px);
  width: 100%;
}
</style>
